import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PagesService from '@/services/CmsServices/PagesService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    loading: false,
    errors: null,
    successOnUpdate: '',
};

export const viewHomePage = createAsyncThunk(
    'pages/viewHomePage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewHomePage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateHomePage = createAsyncThunk(
    'pages/updateHomePage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateHomePage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateAboutPage = createAsyncThunk(
    'pages/updateAboutPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateAboutPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);
export const viewAboutPage = createAsyncThunk(
    'pages/viewAboutPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewAboutPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateLiteraturePage = createAsyncThunk(
    'pages/updateLiteraturePage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateLiteraturePage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewLiteraturePage = createAsyncThunk(
    'pages/viewLiteraturePage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewLiteraturePage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateTechnicalDataPage = createAsyncThunk(
    'pages/updateTechnicalDataPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateTechnicalDataPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewTechnicalDataPage = createAsyncThunk(
    'pages/viewTechnicalDataPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewTechnicalDataPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewCertificationPage = createAsyncThunk(
    'pages/viewCertificationPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewCertificationPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateCertificationPage = createAsyncThunk(
    'pages/updateCertificationPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateCertificationPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewMainPage = createAsyncThunk(
    'pages/viewMainPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewMainPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateMainPage = createAsyncThunk(
    'pages/updateMainPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateMainPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewFaqsPage = createAsyncThunk(
    'pages/viewFaqsPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewFaqsPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateFaqsPage = createAsyncThunk(
    'pages/updateFaqsPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateFaqsPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewCrossReferencePage = createAsyncThunk(
    'pages/viewCrossReferencePage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewCrossReferencePage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateCrossReferencePage = createAsyncThunk(
    'pages/updateCrossReferencePage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateCrossReferencePage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewSolutionsPage = createAsyncThunk(
    'pages/viewSolutionsPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewSolutionsPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateSolutionsPage = createAsyncThunk(
    'pages/updateSolutionsPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateSolutionsPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewTermsAndConditionsPage = createAsyncThunk(
    'pages/viewTermsAndConditionsPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewTermsAndConditionsPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateTermsAndConditionsPage = createAsyncThunk(
    'pages/updateTermsAndConditionsPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateTermsAndConditionsPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewPrivacyPage = createAsyncThunk(
    'pages/viewPrivacyPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewPrivacyPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updatePrivacyPage = createAsyncThunk(
    'pages/updatePrivacyPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updatePrivacyPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewContactPage = createAsyncThunk(
    'pages/viewContactPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewContactPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updateContactPage = createAsyncThunk(
    'pages/updateContactPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updateContactPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewPlantLocationsPage = createAsyncThunk(
    'pages/viewPlantLocationsPage',
    async (_, thunkApi) => {
        try {
            const response = await PagesService.viewPlantLocationsPage();
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const updatePlantLocationsPage = createAsyncThunk(
    'pages/updatePlantLocationsPage',
    async (data, thunkApi) => {
        try {
            const response = await PagesService.updatePlantLocationsPage(data);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

const updatePagesSlice = createSlice({
    name: 'updatePages',
    initialState: model,
    reducers: {
        resetPageStateData: (state) => {
            state.data = null;
        },
        resetPageStateOnSuccess: (state) => {
            state.submitting = false;
            state.successOnUpdate = '';
        },
        resetPageStateOnError: (state) => {
            state.errors = null;
        },
    },
    extraReducers: (builder) => {
        // view home page
        builder.addCase(viewHomePage.pending, (state) => {
            state.loading = true;
        }).addCase(viewHomePage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewHomePage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update home page
        builder.addCase(updateHomePage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateHomePage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Home page updated successfully!';
            state.data = action.payload;
        }).addCase(updateHomePage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view about page
        builder.addCase(viewAboutPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewAboutPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewAboutPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update about page
        builder.addCase(updateAboutPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateAboutPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'About page updated successfully!';
            state.data = action.payload;
        }).addCase(updateAboutPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view literature page
        builder.addCase(viewLiteraturePage.pending, (state) => {
            state.loading = true;
        }).addCase(viewLiteraturePage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewLiteraturePage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update literature page
        builder.addCase(updateLiteraturePage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateLiteraturePage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Literature page updated successfully!';
            state.data = action.payload;
        }).addCase(updateLiteraturePage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view technical data page
        builder.addCase(viewTechnicalDataPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewTechnicalDataPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewTechnicalDataPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update technical data page
        builder.addCase(updateTechnicalDataPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateTechnicalDataPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Technical data page updated successfully!';
            state.data = action.payload;
        }).addCase(updateTechnicalDataPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view certification page
        builder.addCase(viewCertificationPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewCertificationPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewCertificationPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update certification page
        builder.addCase(updateCertificationPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateCertificationPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Certification page updated successfully!';
            state.data = action.payload;
        }).addCase(updateCertificationPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view main page
        builder.addCase(viewMainPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewMainPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewMainPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update main page
        builder.addCase(updateMainPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateMainPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Main Page updated successfully!';
            state.data = action.payload;
        }).addCase(updateMainPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view faq page
        builder.addCase(viewFaqsPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewFaqsPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewFaqsPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update faq page
        builder.addCase(updateFaqsPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateFaqsPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'FAQ page updated successfully!';
            state.data = action.payload;
        }).addCase(updateFaqsPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view cross reference page
        builder.addCase(viewCrossReferencePage.pending, (state) => {
            state.loading = true;
        }).addCase(viewCrossReferencePage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewCrossReferencePage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update cross reference page
        builder.addCase(updateCrossReferencePage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateCrossReferencePage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Cross Reference page updated successfully!';
            state.data = action.payload;
        }).addCase(updateCrossReferencePage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view solutions page
        builder.addCase(viewSolutionsPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewSolutionsPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewSolutionsPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update solutions page
        builder.addCase(updateSolutionsPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateSolutionsPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Solutions page updated successfully!';
            state.data = action.payload;
        }).addCase(updateSolutionsPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view terms and conditions page
        builder.addCase(viewTermsAndConditionsPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewTermsAndConditionsPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewTermsAndConditionsPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update terms and conditions page
        builder.addCase(updateTermsAndConditionsPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateTermsAndConditionsPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Terms and Conditions page updated successfully!';
            state.data = action.payload;
        }).addCase(updateTermsAndConditionsPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view privacy page
        builder.addCase(viewPrivacyPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewPrivacyPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewPrivacyPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update privacy page
        builder.addCase(updatePrivacyPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updatePrivacyPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Privacy page updated successfully!';
            state.data = action.payload;
        }).addCase(updatePrivacyPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view contact page
        builder.addCase(viewContactPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewContactPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewContactPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update contact page
        builder.addCase(updateContactPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updateContactPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Contact page updated successfully!';
            state.data = action.payload;
        }).addCase(updateContactPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view plant locations page
        builder.addCase(viewPlantLocationsPage.pending, (state) => {
            state.loading = true;
        }).addCase(viewPlantLocationsPage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewPlantLocationsPage.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // update plant locations page
        builder.addCase(updatePlantLocationsPage.pending, (state) => {
            state.submitting = true;
        }).addCase(updatePlantLocationsPage.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnUpdate = 'Plant Locations page updated successfully!';
            state.data = action.payload;
        }).addCase(updatePlantLocationsPage.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetPageStateData,
    resetPageStateOnSuccess,
    resetPageStateOnError,
} = updatePagesSlice.actions;

export default updatePagesSlice.reducer;
